import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store/index';

import { ProductCategory } from './product-category';
import { ProductCategoriesActions } from './product-categories.actions';



export type ProductCategoriesState = ProductCategory[];

const /** @type {?} */ initialState: ProductCategoriesState = [];
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
export function reducer(state = initialState, action: Action): ProductCategoriesState {

  switch (action.type) {

    case ProductCategoriesActions.LOAD_PRODUCT_CATEGORIES_SUCCESS: {
      const /** @type {?} */ productCategories: ProductCategory[] = action.payload;
      
      return productCategories;
    }
    
    case ProductCategoriesActions.ADD_PRODUCT_CATEGORY_SUCCESS: {
      const /** @type {?} */ productCategory: ProductCategory = action.payload;
      
      let /** @type {?} */ newState = Object.assign(
        [],
        state
      );

      newState.push(productCategory);

      return newState;
    }
    
    case ProductCategoriesActions.DELETE_PRODUCT_CATEGORY_SUCCESS: {

      const /** @type {?} */ message: string = action.payload.message;
      const /** @type {?} */ productCategoryName: string = action.payload.productCategoryName;

      
      return Object.assign(
        state.filter(p => p.Key !== productCategoryName)
      );
    }

    case ProductCategoriesActions.MOVE_PRODUCT_CATEGORY_TO_SUCCESS: {
      const /** @type {?} */ productCategories: ProductCategory[] = action.payload;

      return productCategories;
    }

    default: {
      return state;
    }

  }

}